'use strict';

var React = require('react');
require('../../theme/breakpoints.js');
require('imask');
var usePrevious = require('../../hooks/usePrevious.js');
require('resize-observer-polyfill');
var iconsMap = require('./iconsMap.js');
var Placeholder = require('./Placeholder.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const thunk = {};
const Icon = React.forwardRef(({ intent, tooltip, name, size, ...props }, ref) => {
    const previousName = usePrevious.usePrevious(name);
    const [lazySvg, setLazySvg] = React.useState(thunk[name] || null);
    React.useEffect(() => {
        let isMounted = true;
        iconsMap.iconsMap[name]().then(({ default: SvgIcon }) => {
            if (isMounted) {
                const element = React__default.default.createElement(SvgIcon, null);
                thunk[name] = element;
                setLazySvg(element);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [name, previousName]);
    return (React__default.default.createElement(styles.Styled.Container, { ...props, ref: ref, title: tooltip, size: size, intent: intent }, lazySvg || React__default.default.createElement(Placeholder.Placeholder, null)));
});

exports.Icon = Icon;
//# sourceMappingURL=component.js.map
